// styles.js
import { styled } from '@mui/material/styles';
import { Box, Button, Card, Radio } from '@mui/material';

// PreviewContainer: Ekranın içeriğini görüntüleyeceğimiz alan
export const PreviewContainer = styled(Box)(() => ({
  position: 'relative',
  height: '500px',
  borderRadius: '12px',
  overflow: 'hidden',
  background: `
    linear-gradient(135deg, #f0f8ff 0%, #e6f7ff 100%),
    repeating-linear-gradient(45deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0) 10px, rgba(200, 230, 255, 0.1) 10px, rgba(200, 230, 255, 0.1) 20px)
  `,
  border: '1px solid #e0f0ff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

// WebsiteMockup: Web sayfasını simüle etmek için kullanılan alan
export const WebsiteMockup = styled(Box)(() => ({
  position: 'absolute',
  width: '100%',
  height: '100%',
  backgroundColor: 'white',
  borderRadius: '8px',
  boxShadow: '0 8px 24px rgba(0, 100, 200, 1)',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column'
}));

// HeaderBar: Web sayfası üst barı
export const HeaderBar = styled(Box)(() => ({
  height: '40px',
  backgroundColor: '#f8fbff',
  borderBottom: '1px solid #e0f0ff',
  display: 'flex',
  alignItems: 'center',
  padding: '0 20px'
}));

// ContentArea: İçerik alanı (Web sayfası içeriği)
export const ContentArea = styled(Box)(() => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#90caf9',
  fontSize: '1.2rem',
  fontWeight: 500,
  background: 'repeating-linear-gradient(45deg, #fafdff, #fafdff 10px, #f5fbff 10px, #f5fbff 20px)'
}));

// ConfigCard: Konfigürasyon kartı
export const ConfigCard = styled(Card)(() => ({
  height: '100%',
  boxShadow: '0 8px 32px rgba(0, 100, 200, 0.1)',
  borderRadius: '12px'
}));

// PreviewCard: Önizleme kartı
export const PreviewCard = styled(Card)(() => ({
  boxShadow: '0 8px 32px rgba(0, 100, 200, 0.1)',
  borderRadius: '12px'
}));

// BlueButton: Kaydet butonu
export const BlueButton = styled(Button)(({buttontext,buttonbackground}) => ({
  background: buttonbackground || '#1976d2',
  color: buttontext || 'white',
  fontWeight: '600',
  padding: '10px 24px',
  boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
  '&:hover': {
    background: buttonbackground || '#1976d2',
    color: buttontext || 'white',
  }
}));

// WhiteButton: Kaydet butonu
export const WhiteButton = styled(Button)(({buttontext,buttonbackground}) => ({
  background: buttonbackground || 'white',
  color: buttontext || 'black',
  border: '1px solid black',
  fontWeight: '600',
  padding: '10px 24px',
  boxShadow: '0 2px 6px rgba(13, 17, 22, 0.3)',
  
}));

export const RedButton = styled(Button)(({buttontext,buttonbackground}) => ({
  background: buttonbackground || '#d23b19ff',
  color: buttontext || 'white',
  fontWeight: '600',
  padding: '10px 24px',
  boxShadow: '0 4px 12px rgba(210, 99, 25, 0.3)',
  '&:hover': {
    background: buttonbackground || '#d23b19ff',
    color: 'white'
  }
  
}));

// StyledRadio: Stilize edilmiş Radio bileşeni
export const StyledRadio = styled(Radio)(() => ({
  '&.Mui-checked': {
    color: '#1976d2'
  }
}));